import { useRef, useState } from "react";
import { Upload, Loader2, FileCheck2 } from "lucide-react";
import { toast } from "sonner";
import { uploadFile, errMsg } from "../../lib/api";

export const FileUpload = ({ onUploaded, label = "Upload", accept = "image/*,.pdf", isPublic = false, testid = "file-upload", value }) => {
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const onChange = async (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    setBusy(true);
    try {
      const res = await uploadFile(f, isPublic);
      onUploaded(res);
    } catch (err) {
      toast.error(errMsg(err));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };
  return (
    <div className="flex items-center gap-3">
      <input ref={ref} type="file" accept={accept} className="hidden" onChange={onChange} data-testid={`${testid}-input`} />
      <button type="button" onClick={() => ref.current.click()} disabled={busy} data-testid={testid}
        className="inline-flex items-center gap-2 rounded-full border border-dashed border-[#00A8B5] px-4 py-2 text-sm font-semibold text-[#0A2540] transition-colors hover:bg-cyan-50 disabled:opacity-60">
        {busy ? <Loader2 size={16} className="animate-spin" /> : <Upload size={16} />}{label}
      </button>
      {value && <span className="flex items-center gap-1 text-xs text-emerald-600"><FileCheck2 size={14} />{value}</span>}
    </div>
  );
};

const STATUS_COLORS = {
  Paid: "bg-emerald-100 text-emerald-700", "Deposit received": "bg-cyan-100 text-cyan-700", "Partially paid": "bg-amber-100 text-amber-700",
  "Not paid": "bg-rose-100 text-rose-700", "To verify": "bg-violet-100 text-violet-700", Refunded: "bg-slate-200 text-slate-700",
  confirmed: "bg-emerald-100 text-emerald-700", pending: "bg-amber-100 text-amber-700", waitlist: "bg-violet-100 text-violet-700", cancelled: "bg-slate-200 text-slate-600",
  verified: "bg-emerald-100 text-emerald-700", rejected: "bg-rose-100 text-rose-700",
  "Registrations open": "bg-emerald-100 text-emerald-700", "Registrations closed": "bg-amber-100 text-amber-700", Published: "bg-cyan-100 text-cyan-700",
  Draft: "bg-slate-100 text-slate-600", Completed: "bg-slate-200 text-slate-700", Cancelled: "bg-rose-100 text-rose-700",
};

export const StatusBadge = ({ status, label, testid }) => (
  <span data-testid={testid} className={`inline-flex whitespace-nowrap rounded-full px-2.5 py-1 text-xs font-semibold ${STATUS_COLORS[status] || "bg-slate-100 text-slate-600"}`}>{label || status}</span>
);
